const styles = theme => ({
    grow: {
        flexGrow: 1
    },
    toolbar: {
        borderBottom: `1px solid rgba(0, 0, 0, 0.12)`,
        marginBottom: theme.spacing(3)
    },
    searchContainer: {
        display: 'flex',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(4),
        alignItems: 'center'
    },
    card: {
        padding: theme.spacing(3),
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: theme.shadows[4]
        }
    },
    cardHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: theme.spacing(2)
    },
    cardTitle: {
        fontWeight: 'bold',
        marginBottom: theme.spacing(1),
        display: '-webkit-box',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden'
    },
    cardDescription: {
        color: theme.palette.text.secondary,
        fontSize: '0.875rem',
        marginBottom: theme.spacing(2),
        flexGrow: 1,
        display: '-webkit-box',
        '-webkit-line-clamp': 3,
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden'
    },
    cardFooter: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingTop: theme.spacing(2),
        borderTop: `1px solid ${theme.palette.divider}`,
        fontSize: '0.75rem',
        color: theme.palette.text.disabled
    },
    modalContent: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '90%',
        maxWidth: 800,
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius * 2,
        boxShadow: theme.shadows[24],
        padding: theme.spacing(4),
        maxHeight: '90vh',
        overflowY: 'auto'
    },
    formField: {
        marginBottom: theme.spacing(3)
    },
    previewImage: {
        width: '100%',
        height: 250,
        objectFit: 'cover',
        borderRadius: theme.shape.borderRadius,
        marginBottom: theme.spacing(3)
    },
    tag: {
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },
    wrapper: {
        backgroundColor: '#fff',
        borderRadius: '8px',
        padding: theme.spacing(3),
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
    },
    filterBar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: theme.spacing(4),
        gap: theme.spacing(3),
        flexWrap: 'wrap'
    },
    searchForm: {
        display: 'flex',
        gap: theme.spacing(1),
        flex: 1,
        minWidth: '300px'
    },
    searchInput: {
        '& .MuiOutlinedInput-root': {
            borderRadius: '50px',
            backgroundColor: '#F8F9FE',
            '& fieldset': {
                borderColor: '#E9ECEF',
            },
            '&:hover fieldset': {
                borderColor: '#111827',
            },
        }
    },
    filterGroup: {
        display: 'flex',
        flexDirection: 'column',
        minWidth: '150px'
    },
    statusFilter: {
        borderRadius: '8px !important',
        backgroundColor: '#F8F9FE',
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E9ECEF',
        }
    },
    tipsContainer: {
        backgroundColor: '#F8F9FE',
        borderRadius: '8px',
        border: '1px solid #E9ECEF',
        padding: theme.spacing(3),
        marginTop: theme.spacing(4)
    }
});

export default styles;
